"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

var _isAbsoluteUrl = _interopRequireDefault(require("is-absolute-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useConvertLinksToRouter = function useConvertLinksToRouter($ref) {
  var navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(function () {
    var _$ref$current;

    var links = $ref === null || $ref === void 0 ? void 0 : (_$ref$current = $ref.current) === null || _$ref$current === void 0 ? void 0 : _$ref$current.querySelectorAll("a");
    links.forEach(function ($link) {
      $link.addEventListener("click", function (e) {
        var href = $link.getAttribute("href");

        if (!(0, _isAbsoluteUrl.default)(href)) {
          e.preventDefault();
          navigate(href);
        }
      });
    });
  }, [$ref, navigate]);
  return null;
};

var _default = useConvertLinksToRouter;
exports.default = _default;